import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AppGalleryRouteGuard } from '../route-guards/app-gallery.route-guard';
import { CreateRouteGuard } from '../route-guards/create.route-guard';
import { FeedRouteGuard } from '../route-guards/feed.route-guard';
import { M365AppsRouteGuard } from '../route-guards/m365-apps.route-guard';
import { ModernStartRouteGuard } from '../route-guards/modern-start.route-guard';
import { MyContentRouteGuard } from '../route-guards/my-content.route-guard';
import { SearchRouteGuard } from '../route-guards/search.route-guard';
import { WacContentHostRouteGuard } from '../route-guards/wac-content-host.route-guard';
import { WacStartRouteGuard } from '../route-guards/wac-start.route-guard';
import { RoutePaths } from '../shared/constants/route-paths.constant';
import { PwaComponent } from './pwa.component';

/**
 * defines the client Angular routes for the application
 * any "loadChildren: '/path/to/module#ModuleName'" is a lazy loaded @NgModule()
 * a code split point will be created by webpack
 * One will need to create a my-module.routing.ts (see Search or AppGallery for example)
 * so that there is a RouteConfig for the Router to load
 *
 * any "component: MyComponent" is an eagerly loaded route, and no code split point
 * will be generated (that @NgModule() will be included in the main bundle)
 */
const appRoutes: Routes = [
    {
        path: RoutePaths.Pwa,
        component: PwaComponent
    },
    {
        path: RoutePaths.OfficeHomeFallback,
        component: PwaComponent
    },
    {
        path: RoutePaths.Search,
        loadChildren: '../search-results/search-results.module#SearchResultsModule',
        canActivate: [
            SearchRouteGuard
        ],
        canLoad: [
            SearchRouteGuard
        ]
    },
    {
        outlet: 'install-wizard',
        path: '',
        children: [
            {
                path: 'open',
                loadChildren: '../install/install-wizard/install-wizard.module#InstallWizardModule'
            }
        ]
    },
    {
        path: RoutePaths.AppGallery,
        loadChildren: '../app-gallery-wrapper/app-gallery-wrapper.module#AppGalleryWrapperModule',
        canActivate: [
            AppGalleryRouteGuard
        ],
        canLoad: [
            AppGalleryRouteGuard
        ]
    },
    {
        path: RoutePaths.ContentHost,
        loadChildren: '../wac-content/wac-content.module#WacContentModule',
        canActivate: [
            WacContentHostRouteGuard
        ],
        canLoad: [
            WacContentHostRouteGuard
        ]
    },
    {
        path: RoutePaths.WacStart,
        loadChildren: '../start-page-wrapper/start-page-wrapper.module#StartPageWrapperModule',
        canActivate: [
            WacStartRouteGuard
        ],
        canLoad: [
            WacStartRouteGuard
        ]
    },
    {
        path: RoutePaths.ModernStart,
        loadChildren: '../modern-start/modern-start.module#ModernStartModule',
        canActivate: [
            ModernStartRouteGuard
        ],
        canLoad: [
            ModernStartRouteGuard
        ]
    },
    {
        path: RoutePaths.Templates,
        loadChildren: '../templates-page-wrapper/templates-page-wrapper.module#TemplatesPageWrapperModule',
        canActivate: [
            WacStartRouteGuard
        ],
        canLoad: [
            WacStartRouteGuard
        ]
    },
    {
        path: RoutePaths.M365Apps,
        loadChildren: '../m365-apps/m365-apps.module#M365AppsModule',
        canActivate: [
            M365AppsRouteGuard
        ],
        canLoad: [
            M365AppsRouteGuard
        ]
    },
    {
        path: RoutePaths.Create,
        loadChildren: '../create-center/create-center-wrapper/create-center-wrapper.module#CreateCenterWrapperModule',
        canActivate: [
            CreateRouteGuard
        ],
        canLoad: [
            CreateRouteGuard
        ]
    },
    {
        path: RoutePaths.MyContent,
        loadChildren: '../my-content/my-content.module#MyContentModule',
        canActivate: [
            MyContentRouteGuard
        ],
        canLoad: [
            MyContentRouteGuard
        ]
    },
    {
        path: RoutePaths.Feed,
        loadChildren: '../feed/feed.module#FeedModule',
        canActivate: [
            FeedRouteGuard
        ],
        canLoad: [
           FeedRouteGuard
        ]
    }
];

@NgModule({
    imports: [
        RouterModule.forRoot(appRoutes, { enableTracing: false, initialNavigation: false, useHash: false })
    ],
    exports: [
        RouterModule
    ]
})
export class PwaRoutingModule { }
